import { setTooltip } from '../../actions/shareCollection';
import { TThunkAction } from '../../types/redux';

const DEFAULT_TOOLTIP_TIMEOUT = 1500;

export const showShareTooltip =
  (text: string, time: number = DEFAULT_TOOLTIP_TIMEOUT): TThunkAction<Promise<void>> =>
  async dispatch => {
    dispatch(setTooltip({ text, state: 'show' }));

    setTimeout(() => {
      dispatch(setTooltip({ text: null, state: 'hide' }));
    }, time);
  };
